<template>
    <v-container class="pa-5" fluid>
        <CreateJobDialog
            :selected-order-components="selectedOrderComponents"
            :machines="machines"
            :is-open="createJobDialog"
            @on-close="closeCreateJobDialog"
        />

        <page-title>Zlecenia / Tworzenie zlecenia</page-title>

        <v-row>
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row justify="end" dense>
                        <v-col cols="12" sm="4" lg="3">
                            <v-text-field
                                v-model="filters.orderProduct__order__productionNumber"
                                append-icon="mdi-magnify"
                                label="Szukaj..."
                                single-line
                                clearable
                                hide-details
                                solo
                                @keyup.enter="changeFilter"
                                @click:append="changeFilter"
                                @click:clear="clearFilter('orderProduct__order__productionNumber')"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        v-model="selectedOrderComponents"
                        :headers="orderComponentsHeaders"
                        :items="orderComponents"
                        :loading="orderComponentsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :mobile-breakpoint="0"
                        show-select
                        name="orderComponentsData"
                        @pagination="updatePagination"
                    >
                        <template #item.productionNumber="{item}">
                            {{ item.productionNumber }}
                        </template>
                        <template #item.productName="{item}">
                            {{ item.productName }}
                        </template>
                        <template #item.version="{item}">
                            {{ item.version }}
                        </template>
                        <template #item.componentName="{item}">
                            <template v-if="item.name">
                                {{ item.name }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                    </v-data-table>
                </v-card>
                <v-btn
                    color="error"
                    medium
                    class="mt-3 mr-3"
                    data-sentry-label="Wróć do listy zleceń"
                    @click="close"
                >
                    Wróć do listy zleceń
                </v-btn>
                <v-fab-transition>
                    <v-btn
                        v-show="selectedOrderComponents.length !== 0"
                        color="success"
                        dark
                        fixed
                        bottom
                        right
                        fab
                        data-sentry-label="Utwórz szkic zlecenia"
                        @click="showCreateJobDialog"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-fab-transition>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import PageTitle from '@/components/common/PageTitle'
import CreateJobDialog from './CreateJobDialog'
import { errorHandler } from '@/utils/errorHandler'
import filters from '@/mixins/dataTableFilters'
import pagination from '@/mixins/dataTablePagination'
import { appConfig } from '@/config'

export default {
    name: 'OrderComponentsList',
    components: {
        PageTitle,
        CreateJobDialog,
    },
    mixins: [ filters, pagination ],
    beforeRouteEnter(to, from, next) {
        store.dispatch('configurations/getMachines', {
            paginate: '',
            query: '?productionDepartment_id=7', // Druk
            shouldSavedInStore: false
        })
            .then(response => {
                next(vm => {
                    vm.machines = response.data.results
                })
            })
            .catch(error => {
                errorHandler(error)
                next(false)
            })
    },
    data() {
        return {
            selectedOrderComponents: [],
            machines: [],
            createJobDialog: false,
            actionLoading: false,
            orderComponentsHeaders: [
                {
                    text: 'Numer produkcyjny',
                    value: 'productionNumber',
                    sortable: false,
                    align: 'left',
                    width: 200
                },
                {
                    text: 'Produkt',
                    value: 'productName',
                    sortable: false,
                    align: 'left',
                },
                {
                    text: 'Wersja',
                    value: 'version',
                    sortable: false,
                    align: 'center',
                    width: 100
                },
                {
                    text: 'Komponent',
                    value: 'componentName',
                    sortable: false,
                    align: 'left',
                },
            ]
        }
    },
    computed: {
        orderComponents() {
            return this.$store.state.jobs.jobs.orderComponents
        },
        orderComponentsLoading() {
            return this.$store.state.jobs.jobs.orderComponentsLoading
        },
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] != '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
        footerProps() {
            return {
                itemsPerPageOptions: appConfig.jobs.orderComponents.rowsPerPageItems
            }
        }
    },
    mounted() {
        this.getOrderComponents()
    },
    methods: {
        getOrderComponents() {
            this.$store.dispatch('jobs/getOrderComponents', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showCreateJobDialog() {
            this.createJobDialog = true
        },
        changeFilter() {
            this.resetPagination()
            this.getOrderComponents()
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getOrderComponents()
            }
            this.clearPaginationPending()
        },
        closeCreateJobDialog() {
            this.createJobDialog = false
        },
        close() {
            this.$router.push({ name: 'jobs' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>
